import Container from './layouts/Container'
//import {Link} from "react-router-dom";
import * as Scroll from 'react-scroll'

export default function Footer() {

  const toTop=()=> {
    Scroll.scroller.scrollTo('top',{
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart'
    });
  }

  return <footer className="footer">
      <Container>
        <div className="c-pagetop" onClick={toTop}>
         <img src="https://towershibuya.jp/assets/images/common/backtop_arrow.png" alt="PAGE TOP" />
        </div>
        <div className="py-28 flex flex-col lg:flex-row items-center">
          <h3 className="text-4xl lg:text-5xl font-bold tracking-tighter leading-tight text-center lg:text-left mb-10 lg:mb-0 lg:pr-4 lg:w-1/2">
              <a href="/">
               <img className="logo" src="https://towershibuya.jp/assets/images/common/logo_large.png" width={280} height={120} alt="TOWER RECORDS SHIBUYA!" />
                </a>
          </h3>
          <div className="flex flex-col lg:flex-row justify-center items-center lg:pl-4 lg:w-1/2">
            <p className="mx-3 bg-black hover:bg-white hover:text-black border border-black text-white font-bold py-3 px-12 lg:px-8 duration-200 transition-colors mb-6 lg:mb-0">
              JASRAC許諾番号：9010254026Y45037
            </p>
            <p href="https://tower.jp" target="_blank" className="mx-3 font-bold hover:underline">
              ©2017 Tower Records Japan Inc.
            </p>
          </div>
        </div>
      </Container>
    </footer>
}
